// Premium Reviews — Infinite Loop Carousel with Peek + Blur Effect

function initPremiumReviews() {
  document.querySelectorAll('.pr-reviews-section').forEach(function(section) {
    var grid    = section.querySelector('.pr-grid');
    var prevBtn = section.querySelector('[id^="pr-prev-"]');
    var nextBtn = section.querySelector('[id^="pr-next-"]');
    var dotsEl  = section.querySelector('[id^="pr-dots-"]');
    if (!grid) return;

    /* ── Clone cards for seamless infinite loop ── */
    var orig = Array.from(grid.querySelectorAll('.pr-card, .pr-image-card'));
    var n    = orig.length;
    if (n < 2) return;

    /* Trailing clones (go forward past last) */
    orig.forEach(function(c) {
      var cl = c.cloneNode(true);
      cl.setAttribute('aria-hidden', 'true');
      grid.appendChild(cl);
    });

    /* Leading clones (go backward past first) */
    orig.slice().reverse().forEach(function(c) {
      var cl = c.cloneNode(true);
      cl.setAttribute('aria-hidden', 'true');
      grid.insertBefore(cl, grid.firstChild);
    });

    /* Full card array: [n leading] + [n real] + [n trailing] */
    var all = Array.from(grid.querySelectorAll('.pr-card, .pr-image-card'));

    /* pointer = index of the LEFT-most fully visible center card */
    var pointer = n;
    var busy    = false;
    var DUR     = 450;

    /* ── Measurements ── */
    function measure() {
      var c = all[0];
      var s = window.getComputedStyle(grid);
      return {
        cardW: c ? c.offsetWidth : 260,
        gap  : parseInt(s.columnGap || s.gap) || 16,
        pad  : parseInt(s.paddingLeft) || 0
      };
    }

    /* Scroll position that shows card[pointer-1] as 50% left peek,
       card[pointer..pointer+2] fully centered,
       card[pointer+3] as 50% right peek.
       On mobile: centers card[pointer] exactly in the viewport. */
    function peekScrollPos(p) {
      var m = measure();
      var isMobile = window.innerWidth <= 768;
      if (isMobile) {
        return p * (m.cardW + m.gap) - (window.innerWidth - m.cardW) / 2;
      } else {
        return m.pad + (p - 1) * (m.cardW + m.gap) + m.cardW / 2;
      }
    }

    /* ── Scroll helper ── */
    function setScroll(pos, smooth) {
      if (smooth) {
        grid.scrollTo({ left: pos, behavior: 'smooth' });
      } else {
        var prev = grid.style.scrollBehavior;
        grid.style.scrollBehavior = 'auto';
        grid.scrollLeft = pos;
        void grid.offsetHeight;
        grid.style.scrollBehavior = prev;
      }
    }

    /* ── Dots ── */
    function updateDots(realIdx) {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.pr-dot').forEach(function(d, i) {
        d.classList.toggle('is-active', i === realIdx);
      });
    }

    /* ── Peek blur/scale: dim the half-visible edge cards ── */
    function updatePeek() {
      all.forEach(function(c) { c.classList.remove('is-peek'); });
      var isMobile = window.innerWidth <= 768;
      if (isMobile) {
        /* Left peek card */
        if (all[pointer - 1]) all[pointer - 1].classList.add('is-peek');
        /* Right peek card */
        if (all[pointer + 1]) all[pointer + 1].classList.add('is-peek');
      } else {
        /* Left peek card */
        if (all[pointer - 1]) all[pointer - 1].classList.add('is-peek');
        /* Right peek card (3 center cards: pointer, pointer+1, pointer+2) */
        if (all[pointer + 3]) all[pointer + 3].classList.add('is-peek');
      }
    }

    /* ── Init ── */
    function init() {
      setScroll(peekScrollPos(pointer), false);
      updateDots(0);
      updatePeek();
    }
    if (document.readyState === 'complete') { init(); }
    else { window.addEventListener('load', init); }

    /* ── Navigate ── */
    function go(dir) {
      if (busy) return;
      busy = true;
      pointer += dir;
      setScroll(peekScrollPos(pointer), true);

      /* Update dots & peek immediately for responsive feel */
      var realIdx = ((pointer - n) % n + n) % n;
      updateDots(realIdx);
      updatePeek();

      setTimeout(function() {
        /* Silently reset if we entered the clone zones */
        if (pointer >= 2 * n) { pointer -= n; setScroll(peekScrollPos(pointer), false); updatePeek(); }
        if (pointer < n)      { pointer += n; setScroll(peekScrollPos(pointer), false); updatePeek(); }
        busy = false;
      }, DUR);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { go(1); });

    /* Re-measure on resize (debounced) */
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        setScroll(peekScrollPos(pointer), false);
      }, 150);
    });
  });
}

/* Boot */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPremiumReviews);
} else {
  initPremiumReviews();
}

/* Re-init in Theme Editor */
document.addEventListener('shopify:section:load', function(e) {
  if (e.target.classList.contains('pr-reviews-section') || e.target.querySelector('.pr-reviews-section')) {
    initPremiumReviews();
  }
});
